import moment from 'moment-timezone';
import store from '@/store/index.js'

const timeZone = store.state?.userInfo?.tenant?.timeZone || 'America/Los_Angeles'

/**
 * If the date is between the start date and the end date, return true, otherwise return false.
 * @param {Date} start - the start date of the range
 * @param {Date} end - the end date of the range
 * @param {Date} date - the date to check
 * @returns A boolean value.
 */
export function isInRange(start, end, date) {
    const isoFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';

    const formattedStartDate = moment(start).startOf('day').format(isoFormat);
    const formattedEndDate = moment(end).endOf('day').format(isoFormat);

    return date >= formattedStartDate && date <= formattedEndDate;
}

/**
 * It takes a label, and returns a range of dates based on that label.
 * 
 * @param {string} label - the label of the range you want to calculate (label = current week, last week, last 2 weeks, last 3 weeks, last 30 days, last 60 days, last 90 days, previous month, last month, last 2 months, last 3 months, current year, last year)
 * @returns An array of two dates.
 */
export function calculateRange(label){
    let start = new Date();
    let end = new Date();

    const range = {
      "current week": function () {
        start = moment().tz(timeZone).utc().startOf('week').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("week").format("YYYY-MM-DD");
      },
      "last week": function () {
        start = moment().tz(timeZone).subtract(1, 'weeks').utc().startOf('week').format("YYYY-MM-DD");
        end = moment().tz(timeZone).subtract(1, 'weeks').utc().endOf('week').format("YYYY-MM-DD");
      },
      "current & previous week": function () {
        start = moment().tz(timeZone).subtract(1, 'weeks').utc().startOf('week').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("week").format("YYYY-MM-DD");
      },
      "last 7 days": function () {
        start = moment().tz(timeZone).subtract(6, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "last 14 days": function () {
        start = moment().tz(timeZone).subtract(13, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "last 21 days": function () {
        start = moment().tz(timeZone).subtract(20, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "last 2 weeks": function () {
        start = moment().tz(timeZone).subtract(1, 'weeks').utc().startOf('week').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("week").format("YYYY-MM-DD");
      },
      "last 3 weeks": function () {
        start = moment().tz(timeZone).subtract(2, 'weeks').utc().startOf('week').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("week").format("YYYY-MM-DD");
      },
      "last 30 days": function () {
        start = moment().tz(timeZone).subtract(29, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end =  moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "last 60 days": function () {
        start = moment().tz(timeZone).subtract(59, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end =  moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "last 90 days": function () {
        start = moment().tz(timeZone).subtract(89, 'days').utc().startOf('day').format("YYYY-MM-DD");
        end =  moment().tz(timeZone).utc().endOf("day").format("YYYY-MM-DD");
      },
      "current month": function () {
        start = moment().tz(timeZone).utc().startOf('month').format("YYYY-MM-DD"); 
        end = moment().tz(timeZone).utc().endOf('month').format("YYYY-MM-DD");
      },
      "previous month": function () {
        start = moment().tz(timeZone).subtract(1, 'months').utc().startOf('month').format("YYYY-MM-DD");
        end = moment().tz(timeZone).subtract(1, 'months').utc().endOf('month').format("YYYY-MM-DD");
      },
      "current & previous month": function () {
        start = moment().tz(timeZone).subtract(1, 'months').utc().startOf('month').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf('month').format("YYYY-MM-DD");
      },
      "current year": function () {
        start = moment().tz(timeZone).utc().startOf('year').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("year").format("YYYY-MM-DD");
      },
      "last year": function () {
        start = moment().tz(timeZone).subtract(1, 'years').utc().startOf('year').format("YYYY-MM-DD");
        end = moment().tz(timeZone).subtract(1, 'years').utc().endOf('year').format("YYYY-MM-DD");
      },
      "current & previous year": function () {
        start = moment().tz(timeZone).subtract(1, 'years').utc().startOf('year').format("YYYY-MM-DD");
        end = moment().tz(timeZone).utc().endOf("year").format("YYYY-MM-DD");
      },
    };

    if(range[label]===undefined) return
    range[label]();

    return [start, end];
}
